import React from 'react'

export const LikeSvg = (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    width="30px"
    height="30px"
    // style='enable-background:new 0 0 512 512;'
  >
    <g>
      <g>
        <path
          d="M83.6,167.3H16.7C7.5,167.3,0,174.7,0,184v300.9c0,9.2,7.5,16.7,16.7,16.7h66.9c9.2,0,16.7-7.5,16.7-16.7V184
        C100.3,174.7,92.8,167.3,83.6,167.3z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M470.3,167.3c-2.7-0.5-128.7,0-128.7,0l17.6-48c12.1-33.2,4.3-83.8-29.4-101.8c-11-5.9-26.3-8.8-38.7-5.7
        c-7.1,1.8-13.3,6.5-17,12.8c-4.3,7.2-3.8,15.7-5.4,23.7c-3.9,20.3-13.5,39.7-28.4,54.2c-26,25.3-106.6,98.3-106.6,98.3v267.5
        h278.6c37.6,0,62.2-42,43.7-74.7c22.1-14.2,29.7-44,16.7-66.9c22.1-14.2,29.7-44,16.7-66.9C527.6,235.2,514.8,174.8,470.3,167.3z"
        />
      </g>
    </g>
  </svg>
)

export const DisLikeSvg = (
  <svg
    version="1.1"
    id="Layer_2"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    width="30px"
    height="30px"
    // style='enable-background:new 0 0 512 512;'
  >
    <g>
      <g>
        <path
          d="M428.6,348.5l66.9-0.1c9.2,0,16.7-7.5,16.7-16.7l-0.4-300.9c0-9.2-7.5-16.7-16.7-16.7l-66.9,0.1
              c-9.2,0-16.7,7.5-16.7,16.7l0.4,300.9C411.8,341,419.4,348.5,428.6,348.5z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M41.9,349.1c2.7,0.5,128.7-0.2,128.7-0.2l-17.5,48.1c-12.1,33.2-4.2,83.8,29.6,101.8
              c11,5.8,26.3,8.8,38.7,5.6c7.1-1.8,13.3-6.5,17-12.8c4.3-7.2,3.8-15.7,5.3-23.7c3.8-20.3,13.4-39.7,28.3-54.2
              c25.9-25.3,106.4-98.5,106.4-98.5L378,47.7L99.4,48.1c-37.6,0-62.2,42.1-43.6,74.8c-22.1,14.2-29.6,44-16.6,66.9
              c-22.1,14.2-29.6,44-16.6,66.9C-15.5,281.2-2.7,341.6,41.9,349.1z"
        />
      </g>
    </g>
  </svg>
)
